// extracted by mini-css-extract-plugin
export var wordContainer = "_oa-0";